import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

export const animalProductionObject = z.object({
  id: z.string().uuid(),
  ruralPropertyId: z.string().uuid(),
  animalProductionType: z.string().max(32),
  quantity: z.number().int(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const animalProductionUpsertInputObject = z.object({
  id: z.string().uuid().nullish(),
  ruralPropertyId: z.string().uuid(),
  animalProductionType: z.string().max(32),
  quantity: z.number().int(),
  sourceFilter: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
})

export type AnimalProductionType = z.infer<typeof animalProductionObject>
export type AnimalProductionUpsertInput = z.infer<typeof animalProductionUpsertInputObject>
